import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

const approvalSystemMeta = {
  roles: ROLES_AND_PERMISSION_ON_ROUTES.APPROVAL_SYSTEM.ROLES,
  permissions: ROLES_AND_PERMISSION_ON_ROUTES.APPROVAL_SYSTEM.PERMISSIONS,
};

const ApprovalSystemRoutes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "ApprovalSystemList",
    component: () => import("../views/ApprovalSystem.vue"),
    meta: approvalSystemMeta,
  },
  {
    path: "create",
    name: "ApprovalSystemCreate",
    component: () => import("../views/ApprovalWorkflowFormPage.vue"),
    meta: approvalSystemMeta,
  },
  {
    path: ":workflowId/edit",
    name: "ApprovalSystemEdit",
    component: () => import("../views/ApprovalWorkflowFormPage.vue"),
    meta: approvalSystemMeta,
  },
  {
    path: ":workflowId",
    name: "ApprovalSystemDetail",
    component: () => import("../views/ApprovalWorkflowFormPage.vue"),
    meta: approvalSystemMeta,
  },
];

export default ApprovalSystemRoutes;
